export default "__VITE_ASSET__CZS79z6q__"